import { IAttributes } from 'angular'

import { RegisterManager } from '../../../managers/register-manager'

/**
 * Controller class for preloading receipt images.
 *
 * @class PreloadReceiptImagesController
 */
export class PreloadReceiptImagesController {
  constructor(
    public registerManager: RegisterManager,
    private $attrs: IAttributes
  ) {
    'ngInject'
  }

  public $postLink() {
    this.$attrs.$addClass('wr-preload-receipt-images')
  }
}
